import { render, staticRenderFns } from "./Storedetail.vue?vue&type=template&id=90a1ada2&scoped=true"
import script from "./Storedetail.vue?vue&type=script&lang=js"
export * from "./Storedetail.vue?vue&type=script&lang=js"
import style0 from "./Storedetail.vue?vue&type=style&index=0&id=90a1ada2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a1ada2",
  null
  
)

export default component.exports